module.exports = __webpack_public_path__ + "static/working-figure-on-a-laptop-with-shorts-c2a25b58a6e5ea0fb10e8829bc9abec9.png";